export const RestClientContext = React.createContext(null)

export const useRestClientContext = () => React.useContext(RestClientContext)
